import { render, staticRenderFns } from "./PrismsUserEditDialog.vue?vue&type=template&id=2f41b3b5&"
import script from "./PrismsUserEditDialog.vue?vue&type=script&lang=js&"
export * from "./PrismsUserEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports